<div class="business-list-view col-md-12 padding-right-0 padding-left-0">

    <!-- Wireframe header (.section-hd + .panel-search). Old header in #legacyHeader. -->
    <div class="gs-biz-list-hd" *ngIf="useWireframeHeader; else legacyHeader">
        <div class="gs-biz-list-row">
            <div class="gs-biz-list-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
                Manage Employees
                <span class="gs-biz-list-count">({{totalCount || 0}})</span>
            </div>
            <div class="gs-biz-list-actions" *ngIf="businessData?.isSuperAdmin === 'true' || businessData?.isAdmin === 'true'">
                <div class="btn-group" dropdown>
                    <button type="button" class="gs-biz-list-btn" dropdownToggle aria-controls="emp-req-filter-menu">
                        {{filterName}}
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
                    </button>
                    <ul id="emp-req-filter-menu" *dropdownMenu class="dropdown-menu dropdown-menu-right no-padding" role="menu">
                        <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'All'" (click)='apply("PENDING")'>All </a></li>
                        <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Ignored'" (click)='apply("IGNORED")'>Ignored </a></li>
                        <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Denied'" (click)='apply("REJECTED")'>Denied</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="gs-biz-list-search">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input type="text" placeholder="Search employees…" aria-label="Search employees" [(ngModel)]="searchKey"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onSearchManage($event)">
            <button *ngIf="searchKey" type="button" class="gs-biz-list-clear" aria-label="Clear search"
                (click)="searchKey = ''; onSearchManage('')">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
        </div>
    </div>

    <ng-template #legacyHeader>
    <div class="hpanel">
        <div class="Bnav panel-body border-radius-top-left-right-6">
            <div class="Bnav-item-11">
                <h6 class=" control-label font-bold font-size-bold" data-toggle="tooltip" data-placement="top"
                    title="{{businessData?.businessName}}">{{businessData?.businessName }}
                </h6>
                <div>
                    <!-- <p>{{totalCount}} Employee<span
                            *ngIf="totalCount>1">s </span></p> -->
                    <!-- <p *ngIf="pendingList?.length === 1">{{pendingList?.length}} Request received</p> -->
                      <p>
  {{totalCount || 0}} {{(totalCount || 0) <= 1 ? 'Employee' : 'Employees'}}
</p>

                </div>
            </div>

            <div class="Bnav-item-22">
                    <input #BusinessManageEmployessText type="text" class="form-control" placeholder="Search Employee" style="z-index: 1;" [(ngModel)]="searchKey"
                        [ngModelOptions]="{standalone: true}" aria-label="Amount (to the nearest dollar)" (input)="onSearchManage(BusinessManageEmployessText.value)">
            </div>

            <div class="Bnav-item-33" *ngIf="businessData?.isSuperAdmin === 'true' || businessData?.isAdmin === 'true'">
                <div class="btn-group ml-10" dropdown container="body">
                    <button id="button-container" class="btn btn-primary" dropdownToggle
                        aria-controls="dropdown-container" style="border-radius: 8px !important; height: 32px !important;">
                        <div class="filter-common" style="gap: 5px !important;">
                          <span>{{filterName}}</span>
                          <ng-icon name="tablerFilter"></ng-icon>
                        </div>
                    </button>
                    <ul id="dropdown-container" *dropdownMenu class="dropdown-menu no-padding" role="menu"
                        aria-labelledby="button-container">
                        <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'All'" (click)='apply("PENDING")'>All </a></li>
                        <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Ignored'" (click)='apply("IGNORED")'>Ignored </a></li>
                          <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Denied'" (click)='apply("REJECTED")'>Denied</a></li>
                    </ul>
                </div>
            </div> 
        </div>


        <!-- </div> -->
    </div>
    </ng-template>

    <ng-container *ngIf="!responseReceived && !loadScroll">
      <div class="follower-body">
        <div class="col-sm-12 col-md-6 col-lg-6 skdjk padding-right-5 padding-left-0"
          *ngFor="let n of [1, 2, 3, 4, 5, 6]">
          <app-common-skeleton [NameOftheScreen]="'usercardWireframe'"></app-common-skeleton>
        </div>
      </div>
    </ng-container>

    <div class="follower-body"  *ngIf="(BusinessManageEmployess | async)?.length > 0" infiniteScroll [alwaysCallback]="true"
      [infiniteScrollDistance]="5" [infiniteScrollThrottle]="300" (scrolled)="onScrollDown()">

    <ng-container *ngIf="responseReceived">
        <div class="col-sm-12 col-md-6 col-lg-6 sdpoo padding-right-5 padding-left-0"
            *ngFor="let data of (BusinessManageEmployess | async) ">
            <app-user-card [userIdInput]="data.userId" [config]="userCardConfig" [button]="'PRIMARY'" [variant]="'wireframe'" [showStats]="false"
                [adminFlag]="businessData?.isSuperAdmin === 'true' || businessData?.isAdmin === 'true'" [refresh]="true" [userDataInput]='data'>
            </app-user-card>
        </div>
    </ng-container>

    

    <ng-container *ngIf="loadScroll">
      <div class="col-sm-12 col-md-6 col-lg-6 padding-right-5 padding-left-0 pd-5"
        *ngFor="let n of [1, 2]">
        <app-common-skeleton [NameOftheScreen]="'usercardWireframe'"></app-common-skeleton>
      </div>
    </ng-container>
    <div class="col-sm-12 pl-1 end" *ngIf="stopScroll && (BusinessManageEmployess | async)?.length > 0 "
      style="text-align: center;padding-top: 1rem;">
      <div class="col-sm-12">
        <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
      </div>
      <div class="col-sm-12">
        <p class="fontchange">You've reached the bottom of the page</p>
      </div>
     </div>
    </div>

    <div class="col-md-12 pad" *ngIf="(BusinessManageEmployess | async)?.length === 0 && stopScroll">
      <app-nodata-found [title]="noDatafound"></app-nodata-found>
    </div>

</div>
